import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import Divider from "@mui/material/Divider";
const Divider_Divider = ()=>{
    const $ = c(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx(Divider, {
            className: "aqa_divider",
            "data-testid": "divider-testid"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
export { Divider_Divider as Divider };
